import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import {
  getGuestDirectorySectionsByMenuSlug,
  getGuestDirectoryIsLoading,
  getGuestDirectoryError,
} from 'selectors/guestDirectory';
import GuestDirectorySectionSelection from 'components/GuestDirectory/SectionSelection';
import Loading from 'components/Loading';
import MessageBlock from 'components/MessageBlock';

interface RouteParams {
  menuId: string;
}

interface Props {
  params: RouteParams;
  children?: React.ReactNode;
}

const GuestDirectoryMenu: React.FC<Props> = ({ params, children }) => {
  const menuSlug = params.menuId;
  const sections = useSelector(state => getGuestDirectorySectionsByMenuSlug(state, menuSlug));
  const isLoading = useSelector(getGuestDirectoryIsLoading);
  const error = useSelector(getGuestDirectoryError);

  if (isLoading) {
    return (
      <Loading>
        <FormattedMessage defaultMessage="Loading sections..." />
      </Loading>
    );
  }

  if (error) {
    return (
      <MessageBlock
        header={<FormattedMessage defaultMessage="Sorry" />}
        body={
          <FormattedMessage defaultMessage="Unable to load guest directory sections. Please try again later." />
        }
      />
    );
  }

  if (sections.length === 0) {
    return (
      <MessageBlock
        header={<FormattedMessage defaultMessage="Sorry" />}
        body={<FormattedMessage defaultMessage="There are no sections available for this menu." />}
      />
    );
  }

  return (
    <>
      <GuestDirectorySectionSelection sections={sections} menuSlug={menuSlug} />
      {children}
    </>
  );
};

export default GuestDirectoryMenu;
